import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, styled, useMediaQuery } from "@mui/material";
import Big from "big.js";
import { camelCase } from "lodash";
import { DescriptionItem, DescriptionList } from "./DescriptionItem";
const ChartContainer = styled('div')(({ theme })=>({
        borderRadius: theme.spacing(0.5),
        display: 'flex',
        flexDirection: 'column',
        height: theme.spacing(16),
        overflow: 'hidden',
        width: theme.spacing(7)
    }));
export const StackedBarChart = (props)=>{
    const isSm = useMediaQuery((theme)=>theme.breakpoints.down('sm'));
    const formattedData = props.data.map((item)=>({
            ...item,
            value: Number.isFinite(item.value) ? item.value : 0
        }));
    const total = formattedData.reduce((sum, segment)=>sum + segment.value, 0);
    return /*#__PURE__*/ _jsxs(Stack, {
        alignItems: "center",
        direction: "row",
        height: "100%",
        spacing: 4,
        children: [
            /*#__PURE__*/ _jsx(ChartContainer, {
                "aria-hidden": "true",
                "data-component": "stackedBarChart",
                children: formattedData.map((item)=>/*#__PURE__*/ _jsx(Box, {
                        bgcolor: item.color,
                        color: item.color,
                        height: `${Big(item.value).div(total || 1).times(100)}%`,
                        width: "100%"
                    }, `${item.color}`))
            }),
            /*#__PURE__*/ _jsx(DescriptionList, {
                direction: isSm ? 'vertical' : 'horizontal',
                children: props.data.map((item)=>/*#__PURE__*/ _jsx(DescriptionItem, {
                        "data-testid": camelCase(item.label),
                        label: item.label,
                        labelColor: item.color,
                        value: item.formattedValue
                    }, `${item.color}`))
            })
        ]
    });
};
StackedBarChart.displayName = 'StackedBarChart';

//# sourceMappingURL=StackedBarChart.js.map